import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';

export const SCULLY_RUNNING = new InjectionToken<Observable<boolean>>(
  'SCULLY_RUNNING'
);

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: SCULLY_RUNNING,
      useValue: false,
    },
  ],
})
export class IcilaluneUtilsModule {}
